import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';

import { AdminAgioFacade } from './admin-agio.facade';
import {
  AgioMetalSetting,
  AgioOverride,
  AgioOverrides,
  AgioOverridesUpdateDto,
  AgioSettings,
  AgioSettingsUpdateDto,
  EffectiveAgioSettings,
} from '@models/resources/agio.model';

/** Dummy-Variante der Agio-Verwaltung (P18) — Seeder-Defaults. */
@Injectable()
export class DummyAdminAgioFacade implements AdminAgioFacade {
  private metals: AgioMetalSetting[] = [
    { metal_id: 1, symbol: 'Au', name: 'Gold', agio_percentage: 1 },
    { metal_id: 2, symbol: 'Ag', name: 'Silber', agio_percentage: 3 },
    { metal_id: 3, symbol: 'Pt', name: 'Platin', agio_percentage: 5 },
    { metal_id: 4, symbol: 'Pd', name: 'Palladium', agio_percentage: 5 },
  ];

  private overrides: AgioOverride[] = [];

  getSettings(): Observable<AgioSettings> {
    return of({ metals: [...this.metals] }).pipe(delay(120));
  }

  saveSettings(dto: AgioSettingsUpdateDto): Observable<AgioSettings> {
    this.metals = this.metals.map((m) => {
      const row = dto.metals.find((x) => x.metal_id === m.metal_id);
      return row ? { ...m, agio_percentage: row.agio_percentage } : m;
    });
    return of({ metals: [...this.metals] }).pipe(delay(120));
  }

  getOverrides(_customerId: number): Observable<AgioOverrides> {
    return of({ overrides: [...this.overrides] }).pipe(delay(120));
  }

  saveOverrides(_customerId: number, dto: AgioOverridesUpdateDto): Observable<AgioOverrides> {
    this.overrides = dto.overrides.filter((o) => o.agio_percentage !== null);
    return of({ overrides: [...this.overrides] }).pipe(delay(120));
  }

  getEffective(_customerId: number): Observable<EffectiveAgioSettings> {
    return of({
      metals: this.metals.map((m) => {
        const o = this.overrides.find((x) => x.metal_id === m.metal_id);
        return o?.agio_percentage != null
          ? { ...m, agio_percentage: o.agio_percentage, agio_percentage_source: 'override' as const }
          : { ...m, agio_percentage_source: 'default' as const };
      }),
    }).pipe(delay(120));
  }
}
